export default {
  title: 'Medication delays',
  delayed: {
    title: 'What happens in case a medication is delayed?',
    description: 'Certain medications can at times be very scarce, so will take us a bit more time to source. This isn\'t a frequent occurrence but when it is the case the pharmacy will let you know the exact number of hours delay. The pharmacy then get to work and move mountains to source your medication & in the meantime, we will always try to reach out personally, ensuring you\'re kept fully in the loop!',
  },
};
